import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  WaitlistRenderer,
  WaitlistRendererQueryString,
} from "./WaitlistRenderer";
import { WaitlistRendererQuery } from "./__generated__/WaitlistRendererQuery.graphql";

export const Waitlist = ({
  date,
  facilityId,
  alwaysOpen,
  courseIds,
}: {
  facilityId: string;
  date: string;
  alwaysOpen?: boolean;
  courseIds: string[] | null;
}) => {
  const [queryRef, loadQuery] = useQueryLoader<WaitlistRendererQuery>(
    WaitlistRendererQueryString
  );

  useEffect(() => {
    if (date) {
      loadQuery(
        {
          date,
          facilityId,
          courseIds,
        },
        { fetchPolicy: "network-only" }
      );
    }
  }, [loadQuery, date, facilityId, courseIds]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        <WaitlistRenderer alwaysOpen={alwaysOpen} queryRef={queryRef} />
      ) : null}
    </Suspense>
  );
};
